import { useState, useCallback, useRef } from 'react';

const useDialogConfirm = (): {
  useTitle?: string;
  useText?: string;
  useOpen?: boolean;
  useFnCallback?: (response: boolean | null) => void;
  useConfirm: (title?: string, text?: string) => Promise<boolean | null>;
} => {
  const [useTitle, setTitle] = useState<string>();
  const [useText, setText] = useState<string>();
  const [useOpen, setOpen] = useState<boolean>();

  const useFnCallback = useRef<((response: boolean | null) => void) | undefined>(undefined);

  const useConfirm = useCallback(async (title?: string, text?: string): Promise<boolean | null> => {
    const setCallback: Promise<boolean | null> = new Promise((resolve) => {
      useFnCallback.current = (response: boolean | null): void => {
        setOpen(false);
        resolve(response);
      };
    });

    setTitle(title);
    setText(text);
    setOpen(true);

    return setCallback;
  }, []);

  return {
    useTitle,
    useText,
    useOpen,
    useFnCallback: useFnCallback.current,
    useConfirm,
  };
};

export default useDialogConfirm;
